module.exports = __webpack_public_path__ + "img/proj5-sco.c646afb2.png";